import BanzaiTheme from './banzai/banzai';

export type SVGImageType = any;
export type CSSType = any;

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

export type Theme = typeof BanzaiTheme;

export type ThemeOverrides = DeepPartial<Theme>;

function deepMap(sourceObject: { [key: string]: any }, targetObject: { [key: string]: any }): any {
  const keys = Object.keys(sourceObject);
  for (const key of keys) {
    const sourceValue = sourceObject[key];
    const targetValue = targetObject[key];
    if (sourceValue instanceof Object) {
      targetObject[key] = deepMap(sourceValue, targetValue || {});
      continue;
    }

    if (!targetValue) {
      targetObject[key] = sourceValue;
      continue;
    }
  }

  return targetObject;
}

export function extendTheme(baseTheme: Theme, overrides: ThemeOverrides): Theme {
  return deepMap(baseTheme, overrides) as Theme;
}
